var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 87,
    viewBox: "0 0 100 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7155 42.4493C84.5781 42.3608 89.3738 44.9093 92.0513 49.5514C95.951 56.3211 93.7596 64.7587 87.2229 68.5435C80.6877 72.3205 72.2826 70.0158 68.3938 63.2523C64.4941 56.4826 66.7026 48.0449 73.2378 44.2602C75.2753 43.0814 77.4993 42.4913 79.7155 42.4493ZM79.5695 36.6021C76.4075 36.658 73.2207 37.4843 70.3072 39.174C60.9656 44.5785 57.8596 56.7357 63.3107 66.1906C68.3985 75.0321 79.2636 78.5591 88.2821 74.5708L94.5191 85.3924C95.3266 86.801 97.1235 87.2871 98.5306 86.478C99.9392 85.6596 100.414 83.8642 99.6068 82.4587L93.2409 71.4011C100.099 65.3334 101.927 54.9389 97.1375 46.6161C93.3947 40.112 86.5256 36.4794 79.5695 36.6021Z",
    fill: "#6C757D",
    fillOpacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0764 0C5.54124 0 0 4.91848 0 11.2114V65.0103C0 71.3032 5.54124 76.2216 12.0764 76.2216H61.0779C64.2089 76.2216 64.2089 71.5206 61.0779 71.5206H12.0764C7.82887 71.5206 4.69173 68.5372 4.69173 65.0103V17.7155H78.4689V31.5314C78.4689 34.6607 83.1668 34.6607 83.1668 31.5314V11.2114C83.1668 4.91848 77.6194 0 71.0826 0H12.0764Z",
    fill: "#6C757D",
    fillOpacity: 0.51
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6741 32.7831C31.0355 32.7831 29.7356 35.9948 31.6365 37.832L37.4434 43.6466L31.6365 49.4627C30.4873 50.612 30.4795 52.471 31.6288 53.6202C32.7765 54.7679 34.637 54.7679 35.7847 53.6202L41.5853 47.8041L47.3859 53.6202C48.5352 54.7679 50.3942 54.7679 51.5434 53.6202C52.6927 52.471 52.6927 50.612 51.5512 49.4627L45.7428 43.6466L51.5512 37.832C53.4832 35.9622 52.0916 32.6868 49.408 32.7831C48.6377 32.8079 47.9186 33.131 47.3844 33.6823L41.5838 39.4907L35.7832 33.6823C35.2365 33.1061 34.4677 32.7831 33.6741 32.7831Z",
    fill: "#6C757D",
    fillOpacity: 0.51
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIcon);
export default __webpack_public_path__ + "static/media/Not_Found_Icon.2d553c2b3c6fec20ce98f2460aeb8653.svg";
export { ForwardRef as ReactComponent };